<script lang="ts">
  import { goto } from '$app/navigation';

  import type { Paragraph } from '../types';

  export let data: Paragraph;

  function handleClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    if (target.tagName.toLowerCase() === 'a') {
      event.preventDefault();

      const href = target.getAttribute('href');

      if (href) {
        goto(href);
      }
    }
  }

  function handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();

      handleClick(event as unknown as MouseEvent);
    }
  }
</script>

<!-- eslint-disable-next-line -->
<div tabindex="0" role="textbox" aria-label="Clickable paragraph" on:click="{handleClick}" on:keydown="{handleKeyDown}">
  <p class="[&>a]:font-medium [&>a]:underline [&>a]:decoration-black/50 dark:[&>a]:decoration-white/50">
    <!-- eslint-disable-next-line -->
    {@html data.text}
  </p>
</div>
